module.exports = __webpack_public_path__ + "static/img/kapian_a.5408c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/kapian_a.png
// module id = XIyv
// module chunks = 69